export default "__VITE_ASSET__fadf7a26__"